var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-btn-icon",
    _vm._g(
      _vm._b(
        { staticClass: "w-btn-next" },
        "w-btn-icon",
        { size: _vm.size, noHover: _vm.noHover },
        false
      ),
      _vm.$listeners
    ),
    [_c("i-next")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }